import { LimitPeriod } from "@obg/ngx.common";

import { NetlossLimitPeriod } from "./netloss-limit.model";

export const NETLOSS_LIMIT_REMOVE_ALERT_ID = "NETLOSS_LIMIT_REMOVE_ALERT_ID";
export const NETLOSS_LIMIT_SUBMIT_ALERT_ID = "NETLOSS_LIMIT_SUBMIT_ALERT_ID";
export const TRANSLATION_PREFIX = "netloss-limit";

export const NETLOSS_LIMIT_PERIODS: NetlossLimitPeriod[] = [
	{ value: LimitPeriod.Daily, label: `${TRANSLATION_PREFIX}.daily` },
	{ value: LimitPeriod.Weekly, label: `${TRANSLATION_PREFIX}.weekly` },
	{ value: LimitPeriod.Monthly, label: `${TRANSLATION_PREFIX}.monthly` },
];
